<header class="header-holder">
  <div>
    <p [style.margin-bottom.rem]="0.25">
      <a href="#main-content" role="button" spbAccessibleLink>Hoppa till
        innehåll</a>
    </p>
    <spb-logo/>
  </div>

  <div class="toggle-holder">
    @if (testMode) {
      <button matButton="outlined">
        <mat-checkbox
          (change)="savingsAccountService.testMode.set($event.checked)">
          Utvecklare (bara i testmiljö)
        </mat-checkbox>
      </button>
    }
    <spb-toggle-button/>
  </div>

</header>